import { PrayerType, DayType } from '../types';

/** Display / resolve order for all prayer types. */
export const PRAYER_TYPES: PrayerType[] = [
  'selichot',
  'shacharit',
  'tekiot',
  'yizkor',
  'musaf',
  'mincha',
  'kabalatShabbat',
  'tefilahZakha',
  'neila',
  'maariv',
  'megillah',
  'hakafot',
  'custom',
];

export const DAY_TYPES: DayType[] = [
  'weekday',
  'sheniHamishi',
  'roshChodesh',
  'chanukah',
  'beinHazmanim',
  'behab',
  'aseretYemeiTeshuva',
  'fastMinor',
  'fastFriday',
  'purim',
  'purimFriday',
  'erevTishaBav',
  'tishaBav',
  'erevShabbos',
  'chanukahFriday',
  'shabbos',
  'chanukahShabbos',
  'erevYomTov',
  'yomTov',
  'roshHashana',
  'roshHashanaFriday',
  'sukkotI',
  'simchatTorah',
  'pesachI',
  'shviiShelPesach',
  'shavuot',
  'yomTovFriday',
  'cholHaMoed',
  'hoshanaRabba',
  'erevYomKippur',
  'yomKippur',
  'selichotFirstNight',
  'selichotBeforeRH',
  'erevRoshHashana',
  'tzomGedalia',
];

export const DAY_TYPE_SECTIONS: {
  key: 'weekday' | 'shabbos' | 'yomTov' | 'selichot';
  dayTypes: DayType[];
}[] = [
  {
    key: 'weekday',
    dayTypes: [
      'weekday', 'sheniHamishi', 'roshChodesh', 'chanukah', 'beinHazmanim', 'aseretYemeiTeshuva', 'fastMinor',
      'fastFriday', 'purim', 'purimFriday', 'erevTishaBav', 'tishaBav',
    ],
  },
  { key: 'shabbos', dayTypes: ['erevShabbos', 'chanukahFriday', 'shabbos', 'chanukahShabbos'] },
  {
    key: 'yomTov',
    dayTypes: [
      'erevYomTov',
      'yomTov',
      'roshHashana',
      'roshHashanaFriday',
      'sukkotI',
      'simchatTorah',
      'pesachI',
      'shviiShelPesach',
      'shavuot',
      'yomTovFriday',
      'cholHaMoed',
      'hoshanaRabba',
      'erevYomKippur',
      'yomKippur',
    ],
  },
  {
    key: 'selichot',
    dayTypes: ['selichotFirstNight', 'selichotBeforeRH', 'erevRoshHashana', 'tzomGedalia', 'behab'],
  },
];

/** Candle lighting: minutes before sunset (Yoel, October 4, 2026: 20). */
export const CANDLE_LIGHTING_MINUTES_BEFORE_SUNSET = 20;

/** Tzeit HaKochavim as the local calendar prints it: sunset + 33 minutes (Yoel, October 4, 2026). */
export const TZEIT_MINUTES_AFTER_SUNSET = 33;

/** Tzeit according to Rabbeinu Tam: sunset + 72 minutes. */
export const RABBEINU_TAM_MINUTES_AFTER_SUNSET = 72;

export const NEIGHBORHOOD_COORDS = {
  lat: 31.702125,
  lng: 35.003423,
};

/** Max upload size for cover images and posters (Storage rules enforce the same). */
export const MAX_UPLOAD_BYTES = 8 * 1024 * 1024;

export const MYZMANIM_FIELDS: Record<string, string> = {
  AlotHashachar: 'עלות השחר',
  Sunrise: 'נץ החמה',
  SunsetDefault: 'שקיעה',
  Tzet: 'צאת הכוכבים',
  TzetRabbeinuTam: 'צאת הכוכבים לרבנו תם',
  Chatzot: 'חצות',
  MinchaGedola: 'מנחה גדולה',
  MinchaKetana: 'מנחה קטנה',
  PlagHamincha: 'פלג המנחה',
  ShemaMA: 'סוף זמן קריאת שמע לפי המגן אברהם',
  ShemaGra: 'סוף זמן קריאת שמע לפי הגר״א',
};

/**
 * Opening hours: "Shabbos ends" (צאת השבת) as the local calendar prints it,
 * this many minutes after sunset (decided by Yoel, October 2, 2026). Used by the
 * 'ShabbosEnds' zman, which only opening hours offer.
 */
export const SHABBOS_ENDS_MINUTES_AFTER_SUNSET = 33;

/** Opening hours: "Opens soon" within this many minutes. */
export const OPENS_SOON_MINUTES = 60;

/** Opening hours: "Closes soon" within this many minutes. */
export const CLOSES_SOON_MINUTES = 30;

/** Listing messages can stay up for at most this many months. */
export const MAX_MESSAGE_MONTHS = 3;
